import { ComponentDefinition } from '@models/index';
import * as angular from 'angular';

import extensions from './allowedExtensions';
import validateFiles from './validation/validateFiles';
import { IDataFolderService } from '@services/data';
import { ILoggerService } from '@services/general';

class UploadButtonController implements angular.IComponentController {
    isLoading: boolean;
    fileList: FileList;
    allowedExtensions = extensions;

    readonly connectionPointGuid: string;
    readonly refresh: () => void;

    static $inject = ['$element', 'dataFolderService', 'translatedLoggerService'];
    constructor(private _$element: angular.IAugmentedJQuery, private _dataFolderService: IDataFolderService, private _loggerService: ILoggerService) {}

    openDialog() {
        this._$element.find('input.file-input').first().trigger('click');
    }

    upload($files: FileList) {
        if ($files?.length) {
            this.isLoading = true;
            const { errors, files } = validateFiles($files);
            if (errors.length) {
                errors.forEach((error) => {
                    this._loggerService.logError(error.message, true, error.data);
                });
                this.isLoading = false;
            } else if (files.length) {
                if (this.connectionPointGuid) {
                    this._dataFolderService
                        .uploads(this.connectionPointGuid, files)
                        .then((data) => {
                            this._loggerService.logSuccess('Files uploaded');
                            if (this.refresh) {
                                this.refresh();
                            }
                        })
                        .catch((e) => {
                            this._loggerService.logError('Failed to upload files');
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            }
        }
    }
}

export const wtUploadButton: ComponentDefinition = {
    componentId: 'wtUploadButton',
    controller: UploadButtonController,
    controllerAs: 'vm',
    template: require('./uploadButton.component.html'),
    bindings: {
        connectionPointGuid: '<',
        isLoading: '=?',
        refresh: '&?'
    }
};
